import styled, { css } from "styled-components";

import { COLOR_BLACK } from "@static/COLORS";

// ===== [props] =====
// - color => default: COLOR_BLACK
// - fontWeight => default: 400
// - textDecorationLine => default: none
// - opacity => default: 1
// - lineHeight => default: normal
// - align => default: start
// - fontSize => default: HOC
// - isEllipsis && line => default: 3 lines

export const Text = styled.p`
  color: ${({ color = COLOR_BLACK }) => color};
  font-weight: ${({ fontWeight = "400" }) => fontWeight};
  font-family: ${({ fontFamily = "IBM Plex Sans Thai" }) => fontFamily};
  text-decoration-line: ${({ textDecorationLine = "none" }) =>
    textDecorationLine};
  opacity: ${({ opacity = 1 }) => opacity};
  line-height: ${({ lineHeight = "normal" }) => lineHeight};
  text-align: ${({ align = "start" }) => align};
  white-space: pre-wrap;
  word-break: ${({ isBreak = true }) => (isBreak ? "break-all" : "normal")};
  font-size: ${({ fontSize = "14px" }) => `${fontSize}`};

  ${({ isEllipsis }) =>
    isEllipsis &&
    css`
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: ${({ lines = 3 }) => lines};
      -webkit-box-orient: vertical;
      overflow: hidden;
    `}
`;
